<template>
  <div v-show="loading.show" style="z-index: 5">
    <div id="loading1" style="position: fixed; border-radius: 50%"></div>
    <div id="loading2" style="position: fixed; border-radius: 50%"></div>

    <div class="fixed-center2" style="text-align: center; z-index: 2">
      <v-icon style="color: white; font-size: 50px">{{loadingIcon}}</v-icon>

      <p
        style="text-align: center; left: -10px; bottom: -50px; color: white; font-size: 20px"
      >We are experiencing a high volume of requests. Please wait while we process your request.</p>
    </div>
  </div>
</template>

<script>
import animator from "@/helpers/animator";
import { mapState } from "vuex";

export default {
  name: "Loading",
  data: () => ({
    rippleColors: [
      "radial-gradient(circle, #F44336, #B71C1C)", //Red
      "radial-gradient(circle, #FF9800, #E65100)", //Orange
      "radial-gradient(circle, #FFEB3B, #FFFF00)", //Yellow
      "radial-gradient(circle, #4CAF50, #1B5E20)", //Green
      "radial-gradient(circle, #2196f3, #0d47a1)", //Blue
      "radial-gradient(circle, #3F51B5, #1A237E)", //Indigo
      "radial-gradient(circle, #9C27B0, #4A148C)", //Purple
      //   "radial-gradient(circle, #607D8B, #263238)", //Blue gray
      "radial-gradient(circle, #424242, #000000)", //Black
    ],
    // rippleColors: [
    //   "radial-gradient(circle, #2196f3, #0d47a1)", //Blue
    //   "radial-gradient(circle, #424242, black)", //Black
    //   "radial-gradient(circle, #FFEB3B, #F57F17)", //Yellow
    //   "radial-gradient(circle, #9C27B0, #4A148C)", //Purple
    //   "radial-gradient(circle, #F44336, #B71C1C)", //Red
    //   "radial-gradient(circle, #4CAF50, #1B5E20)", //Green
    //   "radial-gradient(circle, #607D8B, #263238)", //Blue gray
    //   "radial-gradient(circle, #FF9800, #E65100)" //Orange
    // ],
    rippleEndColors: [
      "#B71C1C", //Red
      "#E65100", //Orange
      "#FFFF00", //Yellow
      "#1B5E20", //Green
      "#0d47a1", //Blue
      "#1A237E", //Indigo
      "#4A148C", //Purple
      //   "radial-gradient(circle, #607D8B, #263238)", //Blue gray
      "#000000", //Black
    ],
    icons: [
      "mdi-seat-recline-extra",
      "mdi-seat-recline-normal",
      //   "mdi-meditation",
      "mdi-human-male",
      "mdi-human-handsdown",
      "mdi-human",
      //   "mdi-human-handsup",
      //   "mdi-motion-sensor",
      "mdi-walk",
      "mdi-run",
      "mdi-run-fast",
      // "mdi-escalator"
      //   "mdi-karate"
    ],
    loadingIcon: "mdi-human-handsdown",
  }),
  computed: {
    ...mapState(["loading"]),
  },
  methods: {
    startLoading() {
      const blackRadial = "radial-gradient(circle, #424242, #000000)";
      this.loadingIcon = "mdi-human-handsdown";
      document.getElementById("loading1").style.backgroundImage = blackRadial;
      document.getElementById("loading2").style.backgroundImage = blackRadial;

      this.ripple(4);
    },
    ripple(count) {
      if (!this.loading.show) {
        return;
      }

      let rippleColorIndex =
        this.rippleColors.length > count
          ? count
          : count % this.rippleColors.length;

      const radialColor = this.rippleColors[rippleColorIndex];
      const rippleEndColor = this.rippleEndColors[rippleColorIndex];
      const loadingEleId = "loading" + (count % 2 === 0 ? "1" : "2");
      const scaleConstant = this.isMobileDevice() ? 2 : 3; //Mobile +2; Desktop +3 or +6
      const scaleTo = Math.ceil(this.windowInfo().max / 56) + scaleConstant;

      const completeCallback = () => {
        if (this.loading.show) {
          this.setStatusBackgroundBarColor(rippleEndColor);
          this.ripple(++count);
        }
      };

      animator.rippleTransition(
        loadingEleId,
        loadingEleId,
        500,
        0,
        scaleTo,
        null,
        radialColor,
        true,
        false,
        completeCallback
      );

      setTimeout(() => {
        let loadingIconIndex =
          this.icons.length > count ? count : count % this.icons.length;
        this.loadingIcon = this.icons[loadingIconIndex];
      }, 370);
    },
  },
  watch: {
    "loading.show": {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) {
          this.setStatusBackgroundBarColor("#000000");
          this.startLoading();
        } else {
          if (!this.loading.notRevertStatusBarColor) {
            this.setThemeColorByMode();

            //Insurance
            setTimeout(() => {
              this.setThemeColorByMode();
            }, 100);
          }
        }
      },
    },
  },
};
</script>

<style>
</style>
